export enum TradeRateGroupType {
  CLIENT_RATES,
  SALES_MARKUP,
  MARKET_RATES,
  TRADER_MARKUP,
}

export namespace TradeRateGroupType {
  let elements = [
    TradeRateGroupType.CLIENT_RATES,
    TradeRateGroupType.SALES_MARKUP,
    TradeRateGroupType.MARKET_RATES,
    TradeRateGroupType.TRADER_MARKUP,
  ];
  let alias = "com.bcdfx.model.TradeRateGroupType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
